<template>
  <component
    :is="layout"
    :channels="$section.products"
    :categories="availableCategories"
    :opts="opts"
    class="epg-grid-view--simple"
  ></component>
</template>
<script>
  import { epgSectionMixin } from '../mixins';

  export default {
    mixins: [
      epgSectionMixin,
    ],
    data() {
      return {
        opts: {
          showScrollableHeader: false,
          showReturnToNow: true,
          showCategoriesFilterList: false,
          showLayoutSwitch: false,
        },
      };
    },
  };
</script>
